import type { IEndpointBearerTokenAuthentication } from '@deity-io/di-data-flows';
import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IAuthorizationProps {
  isEditable: boolean;
  authentication?: Partial<IEndpointBearerTokenAuthentication>;
  parent?: Partial<IEndpointBearerTokenAuthentication>;
  onChange: (key: string[], value: any | null, set?: boolean) => void;
}

const BearerTokenAuthentication: FC<IAuthorizationProps> = ({ isEditable, authentication, parent, onChange }) => (
  <Input
    label={!authentication?.token ? `${parent?.token} (inherited)` : 'Token'}
    type="text"
    name="token"
    id="token"
    value={(authentication as IEndpointBearerTokenAuthentication)?.token}
    onChange={e => onChange(['authentication', 'token'], e.target.value)}
    placeholder="Enter Token"
    disabled={!isEditable}
    sx={{ marginY: 2 }}
    autoComplete="off"
  />
);

export default BearerTokenAuthentication;
